/*
  Marca o cabeçalho como "já rolou". O CSS do tema depende dessa classe
  (cor do menu, dos ícones e o filtro da logo) e nada a aplicava.
  É ela também que troca a logo principal pela segunda.
  Dois gatilhos, para não depender de um só: sentinela observada no topo
  da página e, como reforço, o evento de rolagem.
*/
(function () {
  if (window.__bvHeaderLogo) return;
  window.__bvHeaderLogo = true;

  var LIMIAR = 80;
  var ultimo = null;

  function aplicar(rolou) {
    if (rolou === ultimo) return;
    var h = document.querySelector('.section-header');
    if (!h) return;
    ultimo = rolou;
    h.classList.toggle('scrolled-past-header', rolou);
    document.documentElement.classList.toggle('bv-scrolled', rolou);
  }

  function porScroll() {
    aplicar((window.scrollY || document.documentElement.scrollTop || 0) > LIMIAR);
  }

  function iniciar() {
    porScroll();
    var sentinela = document.createElement('div');
    sentinela.setAttribute('aria-hidden', 'true');
    sentinela.style.cssText = 'position:absolute;top:' + LIMIAR + 'px;left:0;width:1px;height:1px;pointer-events:none;';
    document.body.appendChild(sentinela);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        aplicar(!entradas[0].isIntersecting);
      }, { threshold: 0 }).observe(sentinela);
    }
  }

  window.addEventListener('scroll', function () { window.requestAnimationFrame(porScroll); }, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
